import { defineMessages } from 'react-intl';

export const i18n: {
	owner: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterOwnerPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterOwnerLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterOwnerLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	owner: {
		id: 'search-page.filters.names.owner',
		defaultMessage: 'Owner',
		description:
			'The text is shown as the filter name label in the search filter bar, allowing users to narrow results by the content owner.',
	},
	confluenceFilterOwnerPlaceholder: {
		id: 'search-page.confluence.filter.contributor.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for contributor filter search input',
	},
	confluenceFilterOwnerLabelSelected: {
		id: 'search-page.confluence.filter.contributor.label.selected',
		defaultMessage: 'Selected',
		description:
			'The text is shown as a section heading in the Confluence owner filter drop-down, grouping people that the user has already selected.',
	},
	confluenceFilterOwnerLabelUnselected: {
		id: 'search-page.confluence.filter.contributor.label.unselected',
		defaultMessage: 'Suggested',
		description:
			'The text is shown as a section heading in the Confluence owner filter drop-down, grouping recommended people not yet selected.',
	},
});
